export default __webpack_public_path__ + "static/media/open_hover.d67a6df2.svg";